import React from "react";
import ReactDOM from "react-dom/client";
import "./index.css";
import App from "./App";
import ShopContextProvider from "./context/shop-context";

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <>
    <ShopContextProvider>
      <App />
    </ShopContextProvider>
  </>
);
